import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { GetDeviceParams } from '../dtos';
import { DeviceInfo } from 'src/app/core/proto/device-manager';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Get device params
   * @param getDevicesParams
   */
  getDevice(
    getDevicesParams: GetDeviceParams
  ): Observable<DeviceInfo> {
    return this.apiService.get(
      `/v2/lines/${getDevicesParams.lineId}/device`
    );
  }
}
